import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import LogoutButton from '../../components/app/logout-button';
import { Close2Icon, UserIcon } from '../../components/icons';
import Popup from '../../components/popup';
import { HeaderData } from '../../models/cms';
import User from '../../models/user';
import { State } from '../../store/interfaces';
import Navigation from './Navigation';

interface Customprops {
  data: HeaderData;
  menuOpen: boolean;
  setMenuOpen: (menuOpen: boolean) => void;
  loggedIn: boolean;
}

const Sidemenu = ({ data, menuOpen, setMenuOpen, loggedIn }: Customprops) => {
  const [userDopdown, setUserDropdown] = useState<boolean>(false);
  const { user }: { user?: User; userProfileLoaded: boolean } = useSelector(
    (store: State) => store.authUser
  );
  const userName = (name: string) => {
    const getNameLen = name.split(' ');
    if (getNameLen.length > 2) {
      return getNameLen[0] + ' ' + getNameLen[1] + '...';
    }
    return name;
  };

  const history = useHistory();
  const location = useLocation();

  const profileImageClick = () => {
    history.replace('/dashboard/course');
  };

  const baseUrl = location.pathname;

  return (
    <div
      className={`sidemenu lg:flex fixed lg:static top-0 left-0 bottom-0 p-5 lg:p-0 bg-primary lg:bg-transparent w-full h-full lg:h-auto duration-500 ${
        menuOpen ? 'open' : ''
      }`}
    >
      <div className="flex justify-between items-center pb-24 lg:pb-0">
        <div className="flex items-center gap-3.5 relative">
          {loggedIn ? (
            <>
              <div
                id="user-dropdown"
                onClick={() => setUserDropdown(!userDopdown)}
                className="hidden relative z-10 justify-center items-center w-12 h-12 text-white rounded-full cursor-pointer lg:flex lg:w-9 lg:h-9 bg-tertiary lg:bg-secondary"
              >
                <UserIcon className="w-[18px] lg:w-[14px] h-[21px] lg:h-[17px]" />
              </div>
              <Link
                to="/dashboard"
                onClick={() => setMenuOpen(false)}
                className="lg:hidden"
              >
                <div className="flex items-center">
                  <div className="flex relative z-10 justify-center items-center w-12 h-12 text-white rounded-full bg-tertiary">
                    <UserIcon className="w-[18px] lg:w-[14px] h-[21px] lg:h-[17px]" />
                  </div>
                  <div className="pt-1 ltr:pl-3 rtl:pr-3">
                    <h6 className="font-bold capitalize" title={user?.name}>
                      {user?.name ? userName(user?.name) : user?.name}
                    </h6>
                    <p className="text-xs whitespace-nowrap text-muted">
                      {user?.studentDetails?.studentId}
                    </p>
                  </div>
                </div>
              </Link>

              <Popup
                target="user-dropdown"
                cuePos="pos1"
                align="right"
                top={20}
              >
                <div className="p-4 min-w-[250px]">
                  <div
                    className="flex items-center cursor-pointer xl:ltr:mr-3 xl:rtl:ml-3"
                    onClick={profileImageClick}
                  >
                    <span className="w-[42px] h-[42px] min-h-[42px] leading-[44px] text-center bg-primary text-white rounded-full capitalize">
                      {user?.name.charAt(0)}
                    </span>
                    <div className="ltr:pl-3 rtl:pr-3">
                      <h6 className="font-bold capitalize" title={user?.name}>
                        {user?.name ? userName(user?.name) : user?.name}
                      </h6>
                      <p className="text-xs whitespace-nowrap text-muted">
                        {user?.studentDetails?.studentId}
                      </p>
                    </div>
                  </div>
                  <ul className="grid grid-cols-1 gap-2 pt-5 text-sm">
                    {!user?.isEligibleForGoldenOpertunity && !user?.isTraining && (
                      <li>
                        <a
                          href={process.env.REACT_APP_MOCK_TEST_URL}
                          target="_blank"
                        >
                          Mock Test
                        </a>
                      </li>
                    )}
                    {!user?.studentDetails.isCorporateCustomer && (
                      <li>
                        <Link to={`${baseUrl}/payment`}>Payment</Link>
                      </li>
                    )}
                    <li>
                      <Link to={`${baseUrl}/schedules`}>Schedules</Link>
                    </li>
                    <li>
                      <Link to={`${baseUrl}/my-account`}>My Account</Link>
                    </li>
                    <li>
                      <Link to={`${baseUrl}/test-details`}>Test Details</Link>
                    </li>
                    <li>
                      <Link to={`${baseUrl}/upload-document`}>
                        My Documents
                      </Link>
                    </li>
                    <li>
                      <Link to={`${baseUrl}/my-referral-report`}>
                        My Referrals
                      </Link>
                    </li>
                    <li>
                      <LogoutButton />
                    </li>
                  </ul>
                </div>
              </Popup>
            </>
          ) : (
            <Link
              to="/"
              className="flex relative z-10 justify-center items-center w-12 h-12 text-white rounded-full lg:w-9 lg:h-9 bg-tertiary lg:bg-secondary"
            >
              <UserIcon className="w-[18px] lg:w-[14px] h-[21px] lg:h-[17px]" />
            </Link>
          )}
        </div>
        <span
          className="cursor-pointer lg:hidden"
          onClick={() => setMenuOpen(false)}
        >
          <Close2Icon />
        </span>
      </div>
      <Navigation
        data={data?.navigation}
        closeMainNav={() => setMenuOpen(false)}
        isOpen={menuOpen}
      />
    </div>
  );
};

export default Sidemenu;
